import { combineReducers } from "redux";
import countrySelectorReducer from "./CountrySelector";
import premierPageFrameReducer from "./PremierPageFrame";
import premierPropositionReducer from "./PremierProposition";
import premierSelectorOptionsReducer from "./PremierSelectorOptions";
import subscriptionPlansReducer from "./SubscriptionPlans";
import modalReducer from "./Modal";

const reducers = combineReducers({
  CountrySelector: countrySelectorReducer,
  PremierPageFrame: premierPageFrameReducer,
  PremierProposition: premierPropositionReducer,
  PremierSelectorOptions: premierSelectorOptionsReducer,
  SubscriptionPlans: subscriptionPlansReducer,
  Modal: modalReducer,
});

export default reducers;
